import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}
const MagnifierIcon: FC<Props> = (props) => {
  const { fill, ...prop } = props;
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...prop}
     aria-label="magnifier icon">
      {/* <title>magnifier icon</title> */}
      <g clipPath="url(#clip0_725_3151)">
        <circle
          cx="9.58335"
          cy="9.58329"
          r="7.91667"
          stroke={fill || "currentColor" || "#747981"}
          strokeWidth="1.5"
        />
        <path
          d="M15.4167 15.4166L18.3334 18.3333"
          stroke={fill || "currentColor" || "#747981"}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_725_3151">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MagnifierIcon;
